import { PromoComponentInterface } from '../services/exports/Interfaces';

export type PromoCodeRefresh = 'keep' | 'replace' | 'remove';

type WithComponents = { components?: PromoComponentInterface[] | null } | null | undefined;

/** The component the customer's next order gets: the first one they have not used yet. */
export function nextUnusedComponent(promoCode: WithComponents): PromoComponentInterface | undefined {
  return promoCode?.components?.find((component) => !component.is_used);
}

/**
 * What to do with the promo code cached on the order once the backend has returned its current
 * state. When the customer has used every component (a multi-use code finished on an earlier
 * order), nothing is left to discount and the code comes off the order; when the next component
 * moved on since it was cached, the fresh details replace the cached ones.
 */
export function resolvePromoCodeRefresh(cached: WithComponents, actual: WithComponents): PromoCodeRefresh {
  const actualComponent = nextUnusedComponent(actual);

  if (!actualComponent) {
    return 'remove';
  }

  return nextUnusedComponent(cached)?.id === actualComponent.id ? 'keep' : 'replace';
}
